// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NavigationButtons_wrapper__xABCN"};